import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { AbstractContentPane } from '../models/abstract-content-pane';

@Component({
  selector: 'app-card-mini-pane',
  templateUrl: './card-mini-pane.component.html',
  styleUrls: ['./card-mini-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardMiniPaneComponent extends AbstractContentPane {
  protected onContentLoaded() {
    this.isVisible = !!this.content.length;
  }
}

@NgModule({
  declarations: [CardMiniPaneComponent],
  imports: [CommonModule, SpinnersModule, LibraryElementsModule],
  exports: [CardMiniPaneComponent],
})
class CardMiniPaneModule {}
